import { ThunkType } from "../../../../core/store/reducers";
import { getMarginsReport } from "../api/getMarginsReport";
import fileDownload from "js-file-download";
import { setFetchState } from "../marginsDataSlice";

export const downloadMarginsReport = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.clearing.marginsData;
  const user = store.data.auth.current.user;

  dispatch(setFetchState({ type: "started" }));
  const ordersReport = await dispatch(getMarginsReport(user, filter));
  if (ordersReport) {
    fileDownload(
      new Blob([ordersReport as any], { type: "application/pdf" }),
      "Margins.pdf"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};

